import React, { useState } from "react";
import styles from "./styles.module.css";
import Image001 from "../image/New post 1.png";
import Image002 from "../image/New post 2.png";
import Image003 from "../image/New post 3.png";
import Image004 from "../image/New post 4.png";
import Image005 from "../image/New post 5.png";
import Image009 from "../image/New post 9.png";
import Image0013 from "../image/New post 13.png";
import Image0019 from "../image/New post 19.png";
import Image0015 from "../image/New post 15.webp";
import Image0016 from "../image/New post 16.webp";
import Image0017 from "../image/New post 17.webp";
import Image0018 from "../image/New post 18.webp";

const Image = () => {
  const [workimage, setworkImage] = useState(true);
  const [designimage, setdesignImage] = useState(false);

  const handleWorkOnlyImage = () => {
    setworkImage(true);
    setdesignImage(false);
  };

  const handleUiOnlyImage = () => {
    setworkImage(false);
    setdesignImage(true);
  };

  return (
    <div className={styles.Imagework}>
      <div className={styles.container}>
        <div className={styles.butttons}>
          <button
            type="button"
            className={styles.btn}
            onClick={handleWorkOnlyImage}
          >
            Project
          </button>
          <button
            type="button"
            className={styles.btn}
            onClick={handleUiOnlyImage}
          >
            Design
          </button>
        </div>
        <div className={styles.imagecontainer}>
          {workimage && (
            <div className={styles.workimage}>
              <div className={styles.imageitems}>
                <a
                  href="https://dashboard-nextjs-jayasriraam.vercel.app/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img src={Image001} alt="Work02" className={styles.item} />
                </a>
                <a
                  href="https://jayasriraam-weather.vercel.app/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img src={Image003} alt="Work04" className={styles.item} />
                </a>
              </div>
              <div className={styles.imageitems}>
                <a
                  href="https://marvel-jayasriraam.vercel.app/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img src={Image002} alt="Work03" className={styles.item} />
                </a>
                <a
                  href="https://jay-raam.github.io/Image-Download/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img src={Image005} alt="Work02" className={styles.item} />
                </a>
              </div>
              <div className={styles.imageitems}>
                <a
                  href="https://jayasriraam-protfolio.vercel.app/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img src={Image004} alt="Work05" className={styles.item} />
                </a>
                <a
                  href="https://github.com/Jay-Raam/Movie"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img src={Image009} alt="Work10" className={styles.item} />
                </a>
              </div>
            </div>
          )}
          {designimage && (
            <div className={styles.uiimage}>
              <div className={styles.imageitems}>
                <img src={Image0013} alt="UiWork04" className={styles.item} />
                <img src={Image0017} alt="UiWork08" className={styles.item} />
              </div>
              <div className={styles.imageitems}>
                <img src={Image0019} alt="UiWork05" className={styles.item} />
                <img src={Image0016} alt="UiWork07" className={styles.item} />
              </div>
              <div className={styles.imageitems}>
                <img src={Image0018} alt="UiWork09" className={styles.item} />
                <img src={Image0015} alt="UiWork06" className={styles.item} />
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default Image;
